import _ from 'lodash';
import { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import OrderTable from '../components/OrderTable';
import { SocketRPC, socketEmit } from '../lib/socket';
import { useActiveOrderFilters } from '../store/filters';
import { useOrders } from '../store/orders';
import useUser from "../store/user";

const ActiveOrdersPage = () => {
	const { orders, setOrders, ordersLoaded, setOrdersLoaded } = useOrders();
	const [activePage, setActivePage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const { user } = useUser.getState();
	const {
		orderIdQuery,
		orderDateQuery,
		orderSourceQuery,
		producerNameQuery,
		consumerNameQuery,
		orderStatusQuery,
		sortField,
		sortDirection,
	} = useActiveOrderFilters();

	useEffect(() => {
		if (!user) return;
		const { orderSourceKey, producerKey, partnerKey } = user;
		setOrdersLoaded(false);
		socketEmit(SocketRPC.GetActiveOrders, {
			pageIndex: activePage - 1,
			pageSize,
			orderSourceKey,
			producerKey,
			partnerKey,
			orderIdQuery,
			orderDateQuery,
			orderSourceQuery,
			producerNameQuery,
			consumerNameQuery,
			orderStatusQuery,
			sortField,
			sortDirection,
		})
			.then(res => {
				if (!res.success) {
					throw new Error(res.error);
				}
				setOrders(_.keyBy(res.orders, 'orderKey'));
			})
			.catch(err => {
				toast.error(`Error searching active orders. Please try again`);
				console.log(`Could not search active orders`, err);
			})
			.finally(() => setOrdersLoaded(true));
	}, [
		activePage,
		pageSize,
		user,
		orderIdQuery,
		orderDateQuery,
		producerNameQuery,
		consumerNameQuery,
		orderSourceQuery,
		orderStatusQuery,
		sortField,
		sortDirection,
	]);

	const OrderTableProps = {
		type: 'active',
		orders,
		ordersLoaded,
		paginationProps: {
			activePage,
			setActivePage,
			pageSize,
			setPageSize,
		},
	};

	return OrderTable(OrderTableProps);
};

export default ActiveOrdersPage;
